//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data(){
        return{
            // 图片路径
            imgUrl:'',
            info:'',
            is_btn:false,
            show:false,
        }
    },
    activated(){
        // 获取图片路径
        this.imgUrl =  sessionStorage.getItem('ossPath')
        this.is_btn = false
        let info = this.$route.params.info
        console.log(info);
        this.info = info
    },
    methods:{
        // 取消预约
        async yuyueCancel(){
            let data = {
                id : this.info.id
            }
            this.is_btn = true
            let res = await this.$HTTP.HttpPost('/member/Appointment/delOrder',data)
            if(res.data.code == 200){
                this.show = true
                setTimeout(() => {
                    this.$router.go(-1)
                }, 1500);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/yuyuedetails.vue